/**
 * Copyright by:
 * by ESS-Ehrhardt Software Solutions & Service GmbH
 * Basselscheider Str. 55
 * D-56281 Emmelshausen
 * +49 (0) 67 42 / 87 27 0
 * info@epg.com
 */

export interface GanttChartData {
  total: number;
  finished: number;
  inProgress: number;
  open: number;
  overdue: number;
  overdueNew: number;
  overdueInProgress: number;
  scheduled: number;
  withIncidents: number;
}

export interface GanttSegment {
  label: string;
  value: number;
  percentage: number;
  color: string;
  type: GanttSegmentType;
  icon?: string;
  // Split segment properties
  isSplit?: boolean;
  splitData?: {
    left: {
      type: GanttSegmentType;
      value: number;
      percentage: number;
      color: string;
      label: string;
    };
    right: {
      type: GanttSegmentType;
      value: number;
      percentage: number;
      color: string;
      label: string;
    };
  };
}

export enum GanttSegmentType {
  FINISHED = 'finished',
  IN_PROGRESS = 'inProgress',
  OPEN = 'open',
  OVERDUE = 'overdue',
  OVERDUE_NEW = 'overdueNew',
  SCHEDULED = 'scheduled',
  WITH_INCIDENTS = 'withIncidents'
}

export const GANTT_COLORS = {
  [GanttSegmentType.FINISHED]: 'var(--completed-task-border-color, #33BD1C)',
  [GanttSegmentType.IN_PROGRESS]: 'var(--in-progress-task-border-color, #14A0EF)',
  [GanttSegmentType.OPEN]: 'var(--surface-color, #DEDEDE)',
  [GanttSegmentType.OVERDUE]: 'var(--in-progress-task-border-color, #1080bf)',
  [GanttSegmentType.OVERDUE_NEW]: 'var(--surface-secondary, #B2B2B2)',
  [GanttSegmentType.SCHEDULED]: 'var(--surface-secondary, #b3b3b3)',
  [GanttSegmentType.WITH_INCIDENTS]: 'var(--warn-color, #EF7D00)'
};

export const GANTT_LABELS = {
  [GanttSegmentType.FINISHED]: $localize`:@@ganttSegmentFinished:Finished`,
  [GanttSegmentType.IN_PROGRESS]: $localize`:@@ganttSegmentInProgress:In Progress`,
  [GanttSegmentType.OPEN]: $localize`:@@ganttSegmentOpen:Open`,
  [GanttSegmentType.OVERDUE]: $localize`:@@ganttSegmentOverdue:Overdue`,
  [GanttSegmentType.OVERDUE_NEW]: $localize`:@@ganttSegmentOverdueNew:Overdue New`,
  [GanttSegmentType.SCHEDULED]: $localize`:@@ganttSegmentScheduled:Scheduled`,
  [GanttSegmentType.WITH_INCIDENTS]: $localize`:@@ganttSegmentWithIncidents:With Incidents`
};
